import { render, staticRenderFns } from "./managedInstructionStatusChip.vue?vue&type=template&id=63e7f98a"
import script from "./managedInstructionStatusChip.vue?vue&type=script&lang=js"
export * from "./managedInstructionStatusChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports